import type {
  IBatchedStrokesRquest,
  ILocalListPayload,
  IStrokesToAdd,
} from 'comps/learnosity/v1/question-polypad/usePubNubRemoteSync';
import type { Dispatch } from 'redux';

export const ACTIONS = {
  SAVE_LOCAL_STROKES_FROM_PEER: 'SAVE_LOCAL_STROKES_FROM_PEER',
  REMOVE_LOCAL_STROKES_FROM_PEER: 'REMOVE_LOCAL_STROKES_FROM_PEER',
  STORE_REQUEST_STROKE_DATA: 'STORE_REQUEST_STROKE_DATA',
  REMOVE_REQUEST_STROKE_DATA: 'REMOVE_REQUEST_STROKE_DATA',
  STORE_BATCHED_STROKES_TO_ADD: 'STORE_BATCHED_STROKES_TO_ADD',
  REMOVE_ADDED_BATCHED_STROKES: 'REMOVE_ADDED_BATCHED_STROKES',
};

export const storeLocalStrokesFromPeer =
  (eventData: ILocalListPayload) => (dispatch: Dispatch) => {
    dispatch({
      type: ACTIONS.SAVE_LOCAL_STROKES_FROM_PEER,
      eventData,
    });
  };

export const removeRemoteLocalStrokes = (eventData: { payload: ILocalListPayload }) => {
  return {
    type: ACTIONS.REMOVE_LOCAL_STROKES_FROM_PEER,
    eventData,
  };
};

export const storeRequestedStrokesData =
  (eventData: IBatchedStrokesRquest) => (dispatch: Dispatch) => {
    dispatch({
      type: ACTIONS.STORE_REQUEST_STROKE_DATA,
      eventData,
    });
  };

export const removeRequestedStrokesData = (eventData: {
  payload: IBatchedStrokesRquest;
}) => ({
  type: ACTIONS.REMOVE_REQUEST_STROKE_DATA,
  eventData,
});

export const storeStrokesDataToAdd =
  (eventData: IStrokesToAdd) => (dispatch: Dispatch) => {
    dispatch({
      type: ACTIONS.STORE_BATCHED_STROKES_TO_ADD,
      eventData,
    });
  };

export const removeAddedStrokesData = (eventData: { payload: IStrokesToAdd }) => ({
  type: ACTIONS.REMOVE_ADDED_BATCHED_STROKES,
  eventData,
});
